module.exports = __webpack_public_path__ + "media/images/card-background-detail-3dd2ce275c548a645cca066d194b0f74.svg";